// extracted by mini-css-extract-plugin
module.exports = {"sub_box":"sub_box-yNw9RL3I","sub_nav":"sub_nav-2uiN0d8V clearfix"};